import React from 'react';
import { node, string } from 'prop-types';
import StyledWrapper from './styles';

const ChartWrapper = React.forwardRef(({ children, height, width, ...rest }, ref) => (
  <StyledWrapper ref={ref} height={height} width={width} {...rest}>
    {children}
  </StyledWrapper>
));

ChartWrapper.propTypes = {
  children: node.isRequired,
  height: string,
  minHeight: string,
  width: string,
};

ChartWrapper.defaultProps = {
  height: '500px',
  minHeight: 'auto',
  width: '100%',
};

export default ChartWrapper;
